import React from "react";
import { useGame } from "@empirica/core/player/classic/react";
import { TrackingTaskStage } from "../tracking/TrackingTaskStage";
import { getTrackingRulesParams } from "../tracking/trackingParams";
import { isLossFrameDesign } from "../payoffFrame";

export function Stage1TaskStage() {
  const game = useGame();
  const design = game.get("design");
  const {
    durationSeconds,
    countdownSeconds,
    dollarsPerSecond,
    maxPerParticipant,
    emojiMode,
  } = getTrackingRulesParams(design, 1);
  const lossFrame = isLossFrameDesign(design);

  return (
    <TrackingTaskStage
      heading="Tracking Game"
      description={
        <>
          {lossFrame ? "You can prevent money from being lost by " : "Earn money by "}
          <strong>keeping your cursor on the circle</strong> as it wanders.
        </>
      }
      resultKey="stage1TrackingResult"
      radiusMultiplierKey="stage1CircleRadiusMultiplier"
      durationSeconds={durationSeconds}
      countdownSeconds={countdownSeconds}
      dollarsPerSecond={dollarsPerSecond}
      startingMoneyDollars={maxPerParticipant}
      emojiMode={emojiMode}
      lossFrame={lossFrame}
    />
  );
}
